/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 10b70efd47036b72e8d1dec5d12405f81f712e3a
 */

export type ProductType = typeof ProductType[keyof typeof ProductType];


export const ProductType = {
  ebook: 'ebook',
  audio: 'audio',
  not_supported: 'not_supported',
} as const;
